<div id="SEOC" class="home-tab-container">
    <input id="tab-two" type="radio" name="grp"  checked="checked" /><label for="tab-two">Benefits</label>
    <div id="benefits" class="home-tab-content vehicleBenefits">
        <div>
            <div>
                <h2 class="ins-heading pt-10 pb-10">
                    Features/ Benefits
                </h2>
            </div>
            <div>
                <h3 class="ins-heading pt-10">
                    Loss or damage of the vehicle insured
                </h3>
            </div>
            <div class="ins-answer pt-10 margin6">
                <p>
                    Get covered for natural calamities like floods, typhoons, hurricanes, storms, tempest, etc., and
                    manmade calamities. The policy allows you to stay safe while in transit by rail, road, inland
                    waterway, lift, elevator, or air landslide/rockslide.
                </p>
            </div>
            <div>
                <h3 class="ins-heading pt-10">
                    Third party damage
                </h3>
            </div>
            <div class="ins-answer pt-10 margin6">
                <p>
                    Get protection against legal liability due to accidental damages caused to the third-party property
                    or permanent injury or death to a third party.
                </p>
            </div>
            <div>
                <h3 class="ins-heading pt-10">
                    Personal Accident Cover
                </h3>
            </div>
            <div class="ins-answer pt-10 margin6">
                <p>
                    Get cover for the owner-driver of the vehicle while driving or traveling and mounting or dismounting
                    from the four-wheeler. This benefit is applicable in case of accidents caused due to malfunctions,
                    technical glitches, and more as mentioned in the policy.
                </p>
            </div>
            <div>
                <h2 class="ins-heading pt-10">
                    Add- On Covers
                </h2>
            </div>
            <div>
                <h3 class="ins-heading pt-10">
                    24/7 Spot Assistance
                </h3>
            </div>
            <div class="ins-answer pt-10 margin6">
                <p>
                    Ensure you are never stranded on the road due to any problem associated with your car by getting
                    help for problems like tyre change, assistance for the car’s engine, or assistance in settling in an
                    accident with just a call away regardless of the situation where you are stuck.
                </p>
            </div>
            <div>
                <h3 class="ins-heading pt-10">
                    Key and Lock Replacement
                </h3>
            </div>
            <div class="ins-answer pt-10 margin6">
                <p>
                    Forgetting car keys in the restaurant to losing them at home, both involve expenses that you are
                    likely to incur. With this add-on forget about the entire purchasing and replacing expenses of your
                    car’s locks and keys.
                </p>
            </div>
            <div>
                <h3 class="ins-heading pt-10">
                    Depreciation Shield
                </h3>
            </div>
            <div class="ins-answer pt-10 margin6">
                <p>
                    Nullify the depreciation associated with the car, by not losing the value in the market. Get this
                    add-on for your car and all its spare parts. Highly, recommended for your cars older than 5 years.
                </p>
            </div>
            <div>
                <h3 class="ins-heading pt-10">
                    Engine Protector
                </h3>
            </div>
            <div class="ins-answer pt-10 margin6">
                <p>
                    Protect your most crucial car parts by getting paid for expenses arising due to water ingression,
                    oil leakage, hydrostatic look, and more. Additionally, get cover for damages to the gear box, and
                    gearbox parts too.
                </p>
            </div>
            <div>
                <h3 class="ins-heading pt-10">
                    Consumable Expenses Cover
                </h3>
            </div>
            <div class="ins-answer pt-10 margin6">
                <p>
                    In case of damage to the car, get the add-on two-wheeler cover including consumable expenses that
                    provide coverage for all types of motor vehicle oil, refrigerants, coolants.
                </p>
            </div>
            <div>
                <h3 class="ins-heading pt-10">
                    Personal Baggage
                </h3>
            </div>
            <div class="ins-answer pt-10 margin6">
                <p>
                    From laptops and expensive gadgets to money or money’s worth of valuables protect them with the
                    personal baggage cover.
                </p>
            </div>
        </div>
    </div>
    <input id="tab-one" type="radio" name="grp" /><label for="tab-one">Overview</label>
    <div id="overview" class="home-tab-content overview">
        <div>
            <div class="ins-answer ">
                <p class="">
                    Navigating roads, dodging negligent drivers, following traffic rules - driving is becoming more and
                    more stressful everyday. As a car owner, the consequences of an accident can be humungous. A small
                    dent, broken rear view mirrors to major accidents and even natural disasters, the risks are many.
                </p>
                <p class="">
                    The solution however is right here in front of you - Four Wheeler insurance from Bajaj Finance
                    Limited (BFL). BFL brings to you plans from our most trusted partners that safeguard you against
                    financial losses from damages to your vehicle and also third party liabilities.
                </p>
                <p class="">
                    So, if you're looking to purchase four wheeler insurance, you can be sure you will find the right
                    fit, right here
                </p>
            </div>
        </div>
    </div>
    <input id="tab-three" type="radio" name="grp" /><label for="tab-three">FAQs</label>
    <div id="faqs" class="home-tab-content vehicleFaq faqs">
        <div class="faq-details">
            <h3 #ques1 (click)="openAnswer(ques1)" class="ques">Is Motor Insurance Mandatory?
                <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" stroke="currentColor" stroke-weight="2"
                    class="plus bi bi-plus" viewBox="0 0 16 16">
                    <path
                        d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z" />
                </svg> <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" stroke="currentColor"
                    stroke-weight="2" class="minus bi bi-dash" viewBox="0 0 16 16">
                    <path d="M4 8a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7A.5.5 0 0 1 4 8z" />
                </svg>
            </h3>
            <p id="ans1" class="ans">
                Yes, section 146 of Motor Vehicle Act 1988 mandates that no vehicle can ply on road without insurance
                against third party risks. Hence it is compulsory to get Third Party insurance to cover the liabilities
                in event of injury/ death of third party or damage of property of third party.
            </p>
        </div>
        <div class="faq-details">
            <h3 #ques2 (click)="openAnswer(ques2)" class="ques">How many types of motor insurance are there in India?
                <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" stroke="currentColor" stroke-weight="2"
                    class="plus bi bi-plus" viewBox="0 0 16 16">
                    <path
                        d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z" />
                </svg> <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" stroke="currentColor"
                    stroke-weight="2" class="minus bi bi-dash" viewBox="0 0 16 16">
                    <path d="M4 8a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7A.5.5 0 0 1 4 8z" />
                </svg>
            </h3>
            <p id="ans2" class="ans">
                There are two types of motor insurance in India Third party insurance and comprehensive insurance.
            </p>
        </div>
        <div class="faq-details">
            <h3 #ques3 (click)="openAnswer(ques3)" class="ques">What is third-party motor insurance?
                <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" stroke="currentColor" stroke-weight="2"
                    class="plus bi bi-plus" viewBox="0 0 16 16">
                    <path
                        d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z" />
                </svg> <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" stroke="currentColor"
                    stroke-weight="2" class="minus bi bi-dash" viewBox="0 0 16 16">
                    <path d="M4 8a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7A.5.5 0 0 1 4 8z" />
                </svg>
            </h3>
            <p id="ans3" class="ans">
                Third Party motor insurance is type of policy which covers any liabilities arising in case of injury or
                death of third party or damage to third party property caused by insured vehicle.
            </p>
        </div>
        <div class="faq-details">
            <h3 #ques4 (click)="openAnswer(ques4)" class="ques">What is a comprehensive motor insurance policy?
                <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" stroke="currentColor" stroke-weight="2"
                    class="plus bi bi-plus" viewBox="0 0 16 16">
                    <path
                        d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z" />
                </svg> <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" stroke="currentColor"
                    stroke-weight="2" class="minus bi bi-dash" viewBox="0 0 16 16">
                    <path d="M4 8a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7A.5.5 0 0 1 4 8z" />
                </svg>
            </h3>
            <p id="ans4" class="ans">
                Comprehensive motor insurance covers both third-party liability and damages to your vehicle as well.
            </p>
        </div>
        <div class="faq-details">
            <h3 #ques5 (click)="openAnswer(ques5)" class="ques">What is Zero-Depreciation cover?
                <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" stroke="currentColor" stroke-weight="2"
                    class="plus bi bi-plus" viewBox="0 0 16 16">
                    <path
                        d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z" />
                </svg> <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" stroke="currentColor"
                    stroke-weight="2" class="minus bi bi-dash" viewBox="0 0 16 16">
                    <path d="M4 8a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7A.5.5 0 0 1 4 8z" />
                </svg>
            </h3>
            <p id="ans5" class="ans">
                This cover provides the policyholder complete claim amount on the value of replaced parts without
                deducting any depreciation, following an accident. However, this cover is available only for vehicles
                that are less than three years old.
            </p>
        </div>
        <div class="faq-details">
            <h3 #ques6 (click)="openAnswer(ques6)" class="ques">What is NCB protection cover?
                <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" stroke="currentColor" stroke-weight="2"
                    class="plus bi bi-plus" viewBox="0 0 16 16">
                    <path
                        d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z" />
                </svg> <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" stroke="currentColor"
                    stroke-weight="2" class="minus bi bi-dash" viewBox="0 0 16 16">
                    <path d="M4 8a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7A.5.5 0 0 1 4 8z" />
                </svg>
            </h3>
            <p id="ans6" class="ans">
                No Claim Bonus (NCB) is given for not making any claims during the policy term. As the name suggests,
                the benefit doesn’t nullify the NCB in the event of a claim; it brings down the slab at which the NCB
                discount is given on premium.
            </p>
        </div>
        <div class="faq-details">
            <h3 #ques7 (click)="openAnswer(ques7)" class="ques">What is Return on Invoice Cover?
                <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" stroke="currentColor" stroke-weight="2"
                    class="plus bi bi-plus" viewBox="0 0 16 16">
                    <path
                        d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z" />
                </svg> <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" stroke="currentColor"
                    stroke-weight="2" class="minus bi bi-dash" viewBox="0 0 16 16">
                    <path d="M4 8a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7A.5.5 0 0 1 4 8z" />
                </svg>
            </h3>
            <p id="ans7" class="ans">
                Under this cover, if there’s theft or damages beyond repair it provides you the benefit where you can
                get back the complete amount of your car/bike invoice value, including the cost of registering a new
                vehicle and its road tax, respectively.
            </p>
        </div>
        <div class="faq-details">
            <h3 #ques8 (click)="openAnswer(ques8)" class="ques">What is Road-side Assistance Cover?
                <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" stroke="currentColor" stroke-weight="2"
                    class="plus bi bi-plus" viewBox="0 0 16 16">
                    <path
                        d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z" />
                </svg> <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" stroke="currentColor"
                    stroke-weight="2" class="minus bi bi-dash" viewBox="0 0 16 16">
                    <path d="M4 8a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7A.5.5 0 0 1 4 8z" />
                </svg>
            </h3>
            <p id="ans8" class="ans">
                Under this roadside assistance cover, you can call the support team and they will provide you the
                support for your vehicle on the spot, and repair your vehicle.
            </p>
        </div>
        <div class="faq-details">
            <h3 #ques9 (click)="openAnswer(ques9)" class="ques">What is IDV for four wheeler insurance?
                <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" stroke="currentColor" stroke-weight="2"
                    class="plus bi bi-plus" viewBox="0 0 16 16">
                    <path
                        d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z" />
                </svg> <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" stroke="currentColor"
                    stroke-weight="2" class="minus bi bi-dash" viewBox="0 0 16 16">
                    <path d="M4 8a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7A.5.5 0 0 1 4 8z" />
                </svg>
            </h3>
            <p id="ans9" class="ans">
                IDV or Insured Declared Value for four wheeler insurance means the current market value of the vehicle.
                It corresponds to the maximum sum assured fixed on the vehicle that is paid against total loss or theft
                of the four wheeler.
            </p>
        </div>
        <div class="faq-details">
            <h3 #ques10 (click)="openAnswer(ques10)" class="ques">Are offline and online four wheeler insurance policies
                the same?
                <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" stroke="currentColor" stroke-weight="2"
                    class="plus bi bi-plus" viewBox="0 0 16 16">
                    <path
                        d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z" />
                </svg> <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" stroke="currentColor"
                    stroke-weight="2" class="minus bi bi-dash" viewBox="0 0 16 16">
                    <path d="M4 8a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7A.5.5 0 0 1 4 8z" />
                </svg>
            </h3>
            <p id="ans10" class="ans">
                Yes, they are. In case of online insurance, once you make payment, the policy documents are delivered to
                your registered address.
            </p>
        </div>
        <div class="faq-details">
            <h3 #ques11 (click)="openAnswer(ques11)" class="ques">When & how will I get my four wheeler insurance policy
                if I buy it online?
                <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" stroke="currentColor" stroke-weight="2"
                    class="plus bi bi-plus" viewBox="0 0 16 16">
                    <path
                        d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z" />
                </svg> <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" stroke="currentColor"
                    stroke-weight="2" class="minus bi bi-dash" viewBox="0 0 16 16">
                    <path d="M4 8a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7A.5.5 0 0 1 4 8z" />
                </svg>
            </h3>
            <p id="ans11" class="ans">
                Insurers usually send the soft copy of the four wheeler insurance policy almost immediately after you
                pay your insurance premium online to your registered email id.
            </p>
        </div>
        <div class="faq-details">
            <h3 #ques12 (click)="openAnswer(ques12)" class="ques">What is the advantage of purchasing a four-wheeler
                insurance online?
                <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" stroke="currentColor" stroke-weight="2"
                    class="plus bi bi-plus" viewBox="0 0 16 16">
                    <path
                        d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z" />
                </svg> <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" stroke="currentColor"
                    stroke-weight="2" class="minus bi bi-dash" viewBox="0 0 16 16">
                    <path d="M4 8a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7A.5.5 0 0 1 4 8z" />
                </svg>
            </h3>
            <p id="ans12" class="ans">
                Purchasing a four-wheeler insurance online helps you save time and hassle and the purchase can be done
                from anywhere, anytime.
            </p>
        </div>
        <div class="faq-details">
            <h3 #ques13 (click)="openAnswer(ques13)" class="ques">Do I need to have a valid insurance policy to get my
                new vehicle registered at the RTO?
                <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" stroke="currentColor" stroke-weight="2"
                    class="plus bi bi-plus" viewBox="0 0 16 16">
                    <path
                        d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z" />
                </svg> <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" stroke="currentColor"
                    stroke-weight="2" class="minus bi bi-dash" viewBox="0 0 16 16">
                    <path d="M4 8a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7A.5.5 0 0 1 4 8z" />
                </svg>
            </h3>
            <p id="ans13" class="ans">
                Yes, you need to have an active and valid insurance policy while registering your new vehicle. A valid
                third party (TP) policy is mandatory for registering your vehicle at the RTO.
            </p>
        </div>
    </div>
</div>